// import logo from './logo13-02-22.png';
import './App.css'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import React from 'react'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
export default function App() {
  const [roll, setRoll] = React.useState('')
  const [result, setResult] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [isResultDeclared, setIsResultDeclared] = React.useState(true)
  const [resultName, setResultName] = React.useState('')
  const PRINT = () => {
    window.print();
  }

  React.useEffect(()=>{
    axios.get('/dpr/result/check/season',{
      headers:{
        'Accept':'application/json',
        // 'Access-Control-Allow-Origin': '*',
      }
    
    }).then((res)=>{
      if(res.data.status == "success"){
        setResultName(res.data.data.name)
        setIsResultDeclared(true)
      }else{
        setIsResultDeclared(false)
      }
    })
  },[])
  const submit = () => {
    var formData = new FormData();
    formData.append("roll", roll);
    axios
      .post(`https://cp.sikhmissionarycollege.org/dpr/result`, formData)
      .then((res) => {
        if (res.data.status === 'success') {
          setResult(res.data.data)
          window.scrollTo(0, 500)
        } else {
          setError('No Result Found')
        }
      })
  }
  const resultGrade = () => {
    if (result) {
      if (result.grade === "f") {
        return "Fail";
      } else if (result.grade === "p") {
        return "Pass";
      } else if (result.grade === "m") {
        return "Merit";
      } else if (result.grade === "a") {
        return "A";
      } else if (result.grade === "b") {
        return "B";
      } else if (result.grade === "c") {
        return "C";
      } else {
        return "";
      }
    }
    return "";
  };

  const marksTable = () => {
    if ((result.attendanceStatus === "p") && (result.totalMarks !== null || result.gurbani !== null || result.gurmat !== null || result.ithas !== null)) {

      return (<>
        <table className="table table-bordered mytable">
          <tr>
            <th>ਵਿਸ਼ਾ/Subject</th>
            <th>ਕੁਲ ਅੰਕ /Total Marks</th>
            <th>ਪ੍ਰਾਪਤ ਅੰਕ /Obtained Marks</th>
          </tr>
          <tr>
            <td>ਗੁਰਬਾਣੀ/Gurbani</td>
            <td>100</td>
            <td>{result && result.gurbani}</td>
          </tr>
          <tr>
            <td>ਸਿੱਖ ਇਤਿਹਾਸ/Sikh Ithaas</td>
            <td>100</td>
            <td>{result && result.ithas}</td>
          </tr>
          <tr>
            <td>ਰਹਿਤ ਮਰਯਾਦਾ/Rehat Maryada</td>
            <td>100</td>
            <td>{result && result.gurmat}</td>
          </tr>
          <tr>
            <td>ਕੁਲ ਜੋੜ /Total</td>
            <td>300</td>
            <td>{result && result.totalMarks}</td>
          </tr>
        </table>
        <br />
        <table className="table table-dark table-bordered">
          <tr>
            <th>ਪ੍ਰਾਪਤ ਪ੍ਰਤੀਸ਼ਤ /Percentage</th>
            <td>{result && result.marksPercentage}%</td>
          </tr>
          <tr>
            <th>ਪ੍ਰਾਪਤ ਦਰਜਾ/Grade</th>
            <td>
              {resultGrade()}
            </td>
          </tr>
        </table>
      </>
      );
    } else if (result.attendanceStatus === "a") {
      return (
        <>
          <table className="table table-bordered mytable">
            <tr>
              <td>
                <h2>Absent</h2>
              </td>
            </tr>
          </table>
        </>
      )
    } else {
      return (
        <>
          <table className="table table-bordered mytable">
            <tr>
              <td>
                <h2 className='text-danger'>Status Unknown</h2>
              </td>
            </tr>
          </table>
        </>
      )
    }
  }
  return (
    <div className="App">
      <header className="App-header">
        <h1 class="mt-2">ਸਿੱਖ ਮਿਸ਼ਨਰੀ ਕਾਲਜ, ਲੁਧਿਆਣਾ</h1>
        <p>ਧਾਰਮਿਕ ਪ੍ਰੀਖਿਆ {resultName} ਦਾ ਨਤੀਜਾ</p>
        <img src={`/logo13-02-22.png`} className="App-logo" alt="logo" />
        <div className='noprint'>
          <p>Put Your Roll Number to check your Result</p>
         
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              submit()
            }}
          >
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>ਰੋਲ ਨੰਬਰ/Roll Number</Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => {
                  setRoll(e.target.value)
                }}
                placeholder="Enter Roll Number"
                required
              />
            </Form.Group>
            <Button  variant="primary" type="submit">
              ਨਤੀਜਾ ਦੇਖੋ/Check Result
            </Button>
            
          </Form>
        </div>

        <div style={{ marginBottom: '10px' }}></div>
        {error != null ? (
          error
        ) : (
          <>
            <div className="container">
              <center>
                {result != null ? (
                  <>
                    <table className="table table-dark table-bordered table1">
                      <tr>
                        <th>ਨਾਮ/Name</th>
                        <td>{result && result.name}</td>
                      </tr>
                      <tr>
                        <th>ਰੋਲ ਨੰਬਰ/Roll Number</th>
                        <td>{result && result.rollNumber}</td>
                      </tr>
                      <tr>
                        <th>ਪਿਤਾ ਦਾ ਨਾਮ/Father Name</th>
                        <td>{result && result.fatherName}</td>
                      </tr>

                      <tr>
                        <th>ਸਕੂਲ/School</th>
                        <td>
                          {result && result.school.name} <br />
                          {result.school.address1 + ' ' + result.school.address2 + ' ' + result.school.address3 + ', ' + result.school.city + ' (' + result.school.code + ')'}
                        </td>
                      </tr>
                      <tr>
                        <th>ਸ੍ਰੇਣੀ/Class</th>
                        <td>{result && result.class.label}</td>
                      </tr>
                      <tr>
                        <th>ਦਰਜਾ/Group</th>
                        <td>{result && result.group.id}</td>
                      </tr>
                      <tr></tr>
                    </table>
                    {marksTable(isResultDeclared)}
                    <button class='noprint small btn btn-info' type='button' onClick={PRINT}>
                      PRINT
                    </button>
                    <div class="noprint m-5 p-5"></div>
                  </>
                ) : (
                  ''
                )}
              </center>
            </div>
          </>
        )}
      </header>
    </div>
  )
}



function OnLoadModal(props) {
  const [modalShow, setModalShow] = React.useState(true);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onHide={handleClose}
      show={modalShow}
    >
      <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter">
         Dharmik Parikhya Result
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
        The results of "Dharmik Prikhya" has not been announced yet. Please continue to monitor this website for the latest updates, as the results will be posted here. Thank you for your patience.
        </p>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={handleClose}>Close</Button> */}
      </Modal.Footer>
    </Modal>
  );
}